import { __assign } from "tslib";
import { AsyncState, IAction, IAsyncState } from "../action";
import { actionTypes } from "../actions";
var initialState = {
    scopeNames: new AsyncState(),
    selectedScope: '',
};
export function scopeNames(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actionTypes.loadScopeNames:
            if (action.payload) {
                return state;
            }
            return __assign(__assign({}, initialState), { scopeNames: __assign(__assign({}, state.scopeNames), { isFetching: true, timestamp: new Date() }) });
        case actionTypes.scopeNamesLoaded:
            return __assign(__assign({}, initialState), { scopeNames: __assign(__assign({}, state.scopeNames), action.payload) });
        case actionTypes.loadDataModelNames:
            return __assign(__assign({}, state), { selectedScope: action.payload });
        default:
            return state;
    }
}
